var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"gst-slice-navigation-button",class:{
        'u-rotate-180': _vm.orientation === 'left',
    },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('BaseIcon',{attrs:{"symbol-id":"icons--arrow_right"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }